import React, { Component } from 'react';
import { Context } from 'context';

import Toast from "components/toasts/Toast";

import styles from 'components/toasts/toasts.module.scss';
import isMobile from "ismobilejs";

export default class Toasts extends Component {
    static contextType = Context;
    render() {
        if (isMobile().any) return null;

        return (
            <div className={`${styles.toasts} ${this.context.updateAvailable ? styles.belowBanner : ""}`}>
                {!this.context.networkConnected &&
                    <Toast message={"Network connection interrupted. Some recent changes may not have been saved."} bgColour={"Danger"} closeable={false}/>
                }
                {this.context.toasts.map((toast) =>
                    <Toast
                        key={toast.id}
                        id={toast.id}
                        message={toast.message}
                        bgColour={toast.bgColour}
                        type={toast.type}
                        callBack={toast.callBack}
                        closeable={true}
                        cancelable={toast.cancelable}
                    />
                )}
            </div>
        )
    }
}
